/* import __COLOCATED_TEMPLATE__ from './timestamp-with-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLElement;
  Args: {
    date: Date;
    lowercase?: boolean;
  };
}

const TimestampWithTooltip = templateOnlyComponent<Signature>();
export default TimestampWithTooltip;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Articles::Shared::TimestampWithTooltip': typeof TimestampWithTooltip;
    'articles/shared/timestamp-with-tooltip': typeof TimestampWithTooltip;
  }
}
